<template>
  <div class="page--full bg-white career">
    <div class="career__content">
      <el-row>
        <el-col class="intro">
          <!-- <transition name="fadeInUp"> -->
          <h1 class="intro__header" v-if="showContentByPaging">
            <span class="header">Careers at<br />Soda Labs</span>
          </h1>
          <!-- </transition> -->
          <!-- <transition name="fadeInUp"> -->
          <p class="intro__content" v-if="showContentByPaging">
            We're seeking exceptional people who enjoy working with a purpose and on hard
            challenges.
          </p>
          <!-- </transition> -->
          <hr class="divisor hidden-xs-only" />
        </el-col>
        <el-col class="video__wrapper--mobile hidden-sm-and-up">
          <div class="video video--mobile">
            <iframe
              src="https://player.vimeo.com/video/368202879"
              width="320"
              height="180"
              frameborder="0"
              allow="autoplay; fullscreen"
              allowfullscreen
            ></iframe>
          </div>
        </el-col>
        <el-col class="positions">
          <!-- <transition name="fadeInUp"> -->
          <h2 class="positions__header" v-if="showContentByPaging">Current Opportunities</h2>
          <!-- </transition> -->
          <!-- <transition name="fadeInUp"> -->
          <ul class="positions__list" v-if="showContentByPaging">
            <li
              v-for="(item, index) in positions"
              :key="index"
              :class="{ disabled: item.disabled }"
            >
              <span
                :class="{ underline: !item.disabled }"
                @click="
                  redirectTo({ name: 'job', params: { id: item.id }, disabled: item.disabled })
                "
              >
                {{ item.name }}
              </span>
            </li>
          </ul>
          <!-- </transition> -->
        </el-col>
      </el-row>
    </div>
    <div class="career__video hidden-xs-only">
      <div class="video">
        <iframe
          src="https://player.vimeo.com/video/368202879"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
        ></iframe>
      </div>
      <p class="note">Build your future at Soda Labs</p>
    </div>
  </div>
</template>

<script>
import contentAnimation from '@/mixins/contentAnimation';
import 'element-ui/lib/theme-chalk/display.css';

export default {
  mixins: [contentAnimation],
  data() {
    return {
      positions: [
        { name: 'Senior Back-End-Engineer', id: 'senior-backend-engineer', disabled: false },
        // { name: 'Product Manager', id: 'product-manager', disabled: true },
        { name: 'Quality Assurance Analyst', id: 'quality-assurance-analyst', disabled: false },
      ],
    };
  },
  methods: {
    redirectTo({ name, params, disabled }) {
      if (disabled) return;
      this.$router.push({ name, params });
    },
  },
};
</script>

<style lang="scss" scoped>
.career {
  display: flex;
  justify-content: center;
  padding: 6.375rem 2rem 0;
  overflow: hidden;
  @media (min-width: $sm) {
    padding: 10rem 12% 0;
  }
  @media (min-width: $xl) {
    padding: 12rem 10% 0;
  }
  @media (min-width: $general-iphone-width) and (max-width: $sm) and (min-aspect-ratio: $general-aspect-ratio),
    (max-width: $xs) {
    padding-top: 4rem;
  }
  &__content {
    @media (min-width: $sm) {
      width: 30%;
    }
  }
  &__video {
    flex: 1;
    .note {
      font-size: 0.875rem;
      text-align: center;
      @media (min-width: $xl) {
        font-size: 1.25rem;
      }
    }
  }
}

.intro {
  margin-bottom: 1.5rem;
  @media (min-width: $sm) {
    margin-bottom: 0;
  }
  &__header {
    margin: 0;
    margin-bottom: 1.5rem;
    width: 60%;
    @media (min-width: $sm) {
      width: auto;
    }
  }
  &__content {
    font-size: 0.875rem;
    margin: 0;
    @media (min-width: $xl) {
      margin-right: 4rem;
      font-size: 1.25rem;
    }
  }
}

.divisor {
  border: none;
  height: 1px;
  color: $color-primary;
  background-color: $color-primary;
  margin: 3.5rem 0;
  @media (min-width: $xl) {
    margin-bottom: 4.2rem;
  }
}

.video {
  position: relative;
  padding-top: 56.25%;
  overflow: hidden;
  margin-bottom: 1.25rem;
  &__wrapper {
    &--mobile {
      transform: scale(1.1);
      margin-bottom: 0.5rem;
    }
  }
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.positions {
  &__header {
    margin: 0;
    font-size: 0.75rem;
    font-weight: 500;
    color: #f6acff;
    letter-spacing: 1px;
    text-transform: uppercase;
  }
  &__list {
    list-style-type: none;
    padding-left: 0;
    font-size: 1.625rem;
    line-height: 1;
    @media (min-width: $xl) {
      font-size: 2rem;
      line-height: 1.3;
    }
    @media (min-width: $general-iphone-width) and (max-width: $sm) and (min-aspect-ratio: $general-aspect-ratio),
      (max-width: $xs) {
      margin-top: 1rem;
    }
    font-weight: 500;
    li {
      color: $color-primary;
      margin-bottom: 1rem;
      cursor: pointer;
    }
  }
}

.disabled {
  opacity: 0.3;
}

.fadeInUp-enter-active {
  animation: fadeInUp 0.5s;
}
.fadeInUp-leave-active {
  animation: fadeInUp 0.5s reverse;
}

.temp-image {
  position: relative;
  top: -20%;
}
</style>
